export default "__VITE_ASSET__BrYFtVTo__"